import { TListParams } from 'onboarding/types/crud'
import { TServerListParams } from 'onboarding/types/request'

export const convertToListPayload = (params: TListParams): TServerListParams => {
  const { filter, pagination, skipTotal = true, sort } = params

  return {
    kendoConditions: filter,
    page: pagination.page,
    size: pagination.pageSize,
    sort,
    skipTotal,
  }
}
